export interface ITrame {
  id: string
  createdAt: string
  updatedAt: string
  name: string
  modules: IModule[]
  prosperencesStyled?: boolean
  colored?: boolean
  versionAdhoc?: number
}

interface ModuleType {
  id: string
  name: string
}

export const moduleNames: ModuleType[] = [
  {
    id: 'pageGarde',
    name: 'Page de garde',
  },
  {
    id: 'methodologie',
    name: 'Méthodologie',
  },
  {
    id: 'surfacique',
    name: 'Surfacique',
  },
  {
    id: 'ponctuel',
    name: 'Ponctuel',
  },
]

type TModuleType = typeof moduleNames[number]['name']

export interface IDataPageGarde {
  idLogoOrga: string
  cloudinaryData?: {
    assetId: string
    path: string
    secureUrl: string
  }
  cloudinaryDataCarteStandard?: {
    assetId: string
    path: string
    secureUrl: string
  },
  title?: string
  titleType?: 'title1' | 'title2' | 'title3' | 'text'
  blocs: (IblocText | IblocMap)[] | []
}

interface IDataMethodologie {
  blocs: (IblocText | IblocTableCustom)[]
}

interface IDataSurfacique {
  blocs: (IblocText | IblocTableMap | IblocMap)[]
}

interface IDataPonctuel {
  blocs: (IblocText | IblocTablePonctuel | IblocMap)[]
  typeBloc: 'noBloc' | 'bloc1' | 'bloc2' | 'bloc3' | 'bloc4' | 'bloc5'
}

export interface IModule {
  id: string
  typeModule?: TModuleType
  dataPageGarde?: IDataPageGarde
  dataMethodologie?: IDataMethodologie
  dataSurfacique?: IDataSurfacique
  dataPonctuel?: IDataPonctuel
}

export interface IblocText {
  elemType: 'title1' | 'title2' | 'title3' | 'text'
  value: string
}

export type RankPossibilities = 'rg4' | 'rg5' | 'custom'

export type PotentielChoice = null | 'pot_total' | 'pot1' | 'pot2' | 'pot3' | 'pot4' | 'pot5'

export interface IblocMap {
  elemType: 'map'
  rank: RankPossibilities
  potentielChoice?: PotentielChoice
  isochrone?: {
    type: 'time' | 'distance'
    value: number
    mode: 'car' | 'walk' //| 'bike'
  }
  name?: string
}

export type TableMapMode = 'summarized'| 'detailed'

export interface IblocTableMap {
  elemType: 'tableMap'
  tableauColonnesProduits: string[]
  tableauColonnesMetrics: string[]
  tableMode: TableMapMode
  potentielChoice?: PotentielChoice
}

export interface IblocTablePonctuel {
  elemType: 'tablePonctuel'
  colBloc: string[]
}

export interface IblocTableCustom {
  elemType: 'tableCustom'
  lines: ItableCustomLine[]
  colsWidthPercentage?: number[]
}

export interface cellCustomStyle {
  color?: string
  backgroundColor?: string
  strong?: boolean
  fontSize?: number
}

export interface ItableCustomLine {
  cols: string[]
  style: (cellCustomStyle | undefined)[]
}
